<template>
  <div class="s-textarea-wrapper">
    <v-label v-if="label" class="textarea-label">
      <b>{{ label }}</b>
    </v-label>
    <v-textarea 
      ref="text"
      :value="value" 
      :readonly="readonly"
      :disabled="disabled" 
      :autofocus="autofocus"
      :clearable="clearable"
      :dark="dark"
      :placeholder="placeholder || ' '"
      :counter="showCounter ? max : false"
      :height="height"
      :auto-grow="autoGrow"
      :append-icon="appendIcon"
      :rows="rows"
      dense
      outlined
      hide-details="false"
      class="s-textarea-field"
      :class="{ 'resizable': resizable, 'full-height': fullHeight }"
      @click="click()"
      @input="inputText($event)"
      @keyup.enter="enter" 
      @keypress="validation($event)"
      @blur="handleBlur"
      @click:append="clickAppend"
    />
  </div>
</template>

<script>
export default {
  name: 'sTextarea',
  props: {
    value: null,
    color: { type: String, default: "primary" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: " " },
    max: { type: String, default: "256" },
    type: { type: String, default: "text" },
    dark: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    number: { type: Boolean, default: false },
    decimal: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    search: { type: Boolean, default: false },
    showCounter: { type: Boolean, default: false },
    
    // Props para altura dinámica - simplificadas
    height: { type: Number, default: null },
    autoGrow: { type: Boolean, default: true },
    resizable: { type: Boolean, default: true },
    rows: { type: Number, default: 3 },
    fullHeight: { type: Boolean, default: false },
    appendIcon: { type: String, default: "" }
  },
  
  methods: {
    click() {
      this.$emit('click');
    },
    
    handleBlur() {
      this.$emit('blur');
    },
    
    clickAppend() {
      this.$emit('click:append');
    },
    
    focus() {
      this.$refs.text.focus();
    },
    
    validation(evt) {
      if (this.number || this.type === "number") {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
          evt.preventDefault();
        } else {
          return true;
        }
      }

      if (this.decimal) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46)) {
          evt.preventDefault();
        } else {
          return true;
        }
      }
    },
    
    inputText(item) {
      if (item == null) { 
        item = ""; 
        this.$emit("input", '');
      } else {
        this.item = item;
        if (!this.search) {
          this.$emit("input", item);
        } else {
          this.debouncedGetAnswer();
        }
      }
    },
    
    enter() {
      this.$emit("keyupEnter");
    },
    
    getAnswer() {
      this.$emit("input", this.item);
    }
  },
  
  created() {
    if (this.search) {
      this.debouncedGetAnswer = _.debounce(this.getAnswer, 220);
    }
  },
  
  data: () => ({
    item: ""
  }),
};
</script>
<style scoped>
/* Wrapper principal */
.s-textarea-wrapper {
  position: relative;
  width: 100%;
  padding-top: -2px;
  margin-top: -2px;
}

/* Label personalizado */
.textarea-label {
  margin-bottom: 4px;
  display: block;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}

.textarea-label b {
  font-weight: 600;
}

/* Remover restricciones de altura del CSS original */
.s-textarea-field >>> .v-input__slot {
  min-height: auto !important;
  max-height: none !important;
}

.s-textarea-field >>> .v-input__control {
  min-height: auto !important;
}

/* Textarea redimensionable */
.s-textarea-field.resizable >>> textarea {
  resize: vertical;
  overflow: auto;
  min-height: 60px;
}

/* Altura completa */
.s-textarea-field.full-height {
  height: 100%;
}

.s-textarea-field.full-height >>> .v-input__control,
.s-textarea-field.full-height >>> .v-input__slot,
.s-textarea-field.full-height >>> textarea {
  height: 100%;
}

/* Para modo oscuro */
.theme--dark .textarea-label {
  color: rgba(255, 255, 255, 0.87);
}

/* Estados donde no se puede redimensionar */
.s-textarea-field >>> .v-input--is-disabled textarea,
.s-textarea-field >>> .v-input--is-readonly textarea {
  resize: none;
}

/* Scroll personalizado */
.s-textarea-field >>> textarea::-webkit-scrollbar {
  width: 6px;
}

.s-textarea-field >>> textarea::-webkit-scrollbar-track {
  background: transparent;
}

.s-textarea-field >>> textarea::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.s-textarea-field >>> textarea::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
</style>
